import styled from 'styled-components';

export const StyledMightyFuCasino = styled.div`
  box-sizing: border-box;
  font-family: var(--font-family), Arial;
  width: 100%;
  height: 100%;
  position: relative;
  background: ${(props: any) => `url("${props.backgroundSrc}")`};
  background-size: 100% 100%;
  background-position: center;
  padding: 4px 8px 5px 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .tooltip-icon {
    height: 24px;
  }

  .mighty-fu-bundle {
    &__tooltip {
      position: absolute;
      right: 8px;
      margin-top: 2px;

      .tooltip-container {
        height: 100%;
      }
    }

    &__products-container {
      position: relative;
      top: -10px;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
      gap: 10px;
      justify-content: center;
    }
  }
` as any;
